// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__3mG6N","leftSide":"styles_leftSide__Q_D4h","description":"styles_description__qJe4w","image":"styles_image__3MlZz"};